import { Link } from "react-router-dom";

const QuestionCard = ({ question }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    return status === "answered" ? "success" : "warning";
  };

  return (
    <div className="question-card-item">
      <Link to={`/questions/${question.id}`} className="text-decoration-none">
        <div className="card question-card-hover shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div className="question-badges">
                <span className="badge bg-secondary me-2">
                  {question.category || "General"}
                </span>
                <span className={`badge bg-${getStatusColor(question.status)} text-capitalize`}>
                  {question.status}
                </span>
              </div>
              <div className="question-date">
                <small className="text-muted">
                  <i className="fas fa-calendar me-1"></i>
                  {formatDate(question.created_at)}
                </small>
              </div>
            </div>

            <h6 className="question-title mb-2">
              <i className="fas fa-question-circle text-primary me-2"></i>
              {question.question_text}
            </h6>

            {question.answer_text ? (
              <div className="answer-preview">
                <p className="text-muted mb-2" title={question.answer_text}>
                  <i className="fas fa-reply text-success me-1"></i>
                  <strong>Answer:</strong> {question.answer_text.substring(0, 150)}
                  {question.answer_text.length > 150 && "..."}
                </p>
                {question.answered_at && (
                  <small className="text-muted">
                    <i className="fas fa-clock me-1"></i>
                    Answered on {formatDate(question.answered_at)}
                  </small>
                )}
              </div>
            ) : (
              <div className="no-answer-preview">
                <p className="text-muted mb-0">
                  <i className="fas fa-hourglass-half text-warning me-1"></i>
                  <em>Waiting for instructor response...</em>
                </p>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default QuestionCard;
